import { createSlice } from '@reduxjs/toolkit'
// import { v4 as uuidv4 } from 'uuid';

export const catalog = createSlice({
    name: 'catalog',
    initialState: {
        readOnly: false,
        categories: [],
        records: 10,
    },
    reducers: {
        setMediaCategories: (state, action) => {
            state.categories = action.payload;
        },
        setNumberOfRecords: (state, action) => {
            state.records = action.payload;
        },
        setCatalogReadOnly: (state, action) => {
            state.readOnly = action.payload;
        }
    },
});

export const { setMediaCategories, setNumberOfRecords, setCatalogReadOnly } = catalog.actions;